import _ from 'lodash';
import React from 'react';

import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';
import { InboxEntryStatus } from '@/src/components/project/Inbox2/types';
import { cn } from '@/src/util/ui';
type StatusBadgeProps = {
  status: InboxEntryStatus;
  className?: string;
  isDisabled?: boolean;
  isDuplicate?: boolean;
  isArrowVisible?: boolean;
};

const statusStyles = {
  [InboxEntryStatus.New.toUpperCase()]: 'tw-bg-cfo-blue-200 tw-text-cfo-blue-700',
  [InboxEntryStatus.Open.toUpperCase()]: 'tw-bg-cfo-green-100 tw-text-cfo-green-300',
  [InboxEntryStatus.Closed.toUpperCase()]: '!tw-border-cfo-black tw-text-cfo-black',
};

const StatusBadge = ({
  status,
  className = '',
  isDisabled = false,
  isDuplicate = false,
  isArrowVisible = false,
}: StatusBadgeProps) => {
  const myStatus = _.upperFirst(status);

  if (isDuplicate) {
    return (
      <div
        className={cn(
          'container--duplicate',
          'tw-flex tw-items-center tw-justify-center',
          'tw-w-[95px]',
          'tw-bg-cfo-grey-300',
          'tw-border-none',
          'tw-font-brandonTextMedium tw-text-cfo-grey-600',
          'tw-px-[10px] tw-py-[1px] tw-mx-[5px]',
          'tw-rounded-[34px] tw-leading-[20px]',
          className
        )}
      >
        <span>Duplicate</span>

        {isArrowVisible && <Icon icon={ICONS.dropdown} />}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'tw-flex tw-items-center',
        'tw-min-w-[120px] tw-w-full',
        'tw-font-brandonTextMedium',
        'tw-py-[5px] tw-mx-[5px]',
        'tw-border-solid tw-border-[1px] tw-border-transparent',
        'tw-rounded-[20px] tw-leading-[20px]',
        isArrowVisible ? 'tw-justify-between tw-px-[20px] ' : ' tw-justify-center tw-px-[10px] ',
        isDisabled && 'tw-cursor-not-allowed',
        statusStyles[myStatus.toUpperCase()],
        className
      )}
    >
      {myStatus}

      {isArrowVisible && <Icon icon={ICONS.dropdown} />}
    </div>
  );
};

export default StatusBadge;
